import request from '../../../common/request/index.js'
const api = request.api

export default {
  page: (params) => {
    return api.post('enterprise/enterprise/page', params)
  },
  list: (params) => {
    return api.post('enterprise/enterprise/list', params)
  },
  get: (id) => {
    return api.get(`enterprise/enterprise/${id}`)
  },
  create: (data) => {
    return api.post('enterprise/enterprise', data)
  },
  update: (data) => {
    return api.put('enterprise/enterprise', data)
  },
  delete: (id) => {
    return api.delete(`enterprise/enterprise/${id}`)
  },

  // ★ 新增：导出
  export: (params) => {
    return api.post('enterprise/enterprise/export', params, { responseType: 'blob' })
  }
}